import "./index.css";
import { ConfigService } from "@shuttlerock/configuration";
import { initialiseOtel, initialiseLogging } from "@shuttlerock/observability";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { routes } from "virtual:routes";
import { connectAnalytics } from "./components/Analytics/connect-analytics";
import { logCaughtError, logRouterError } from "./components/ErrorPage/route-error-logging";

const allowUrls = [ConfigService.SUPERGRAPH_BASE_URL(), ConfigService.DOCUMENT_BASE_URL()];

initialiseOtel({
  endpoint: ConfigService.OTEL_EXPORTER_OTLP_ENDPOINT(),
  environment: ConfigService.ENVIRONMENT(),
  appVersion: ConfigService.APP_VERSION(),
  serviceName: "cloud-ui",
  allowedUrls: allowUrls,
});
initialiseLogging(
  ConfigService.SENTRY_ENABLED(),
  ConfigService.ENVIRONMENT(),
  ConfigService.APP_VERSION(),
);

const router = createBrowserRouter(routes);
const disconnectAnalytics = connectAnalytics(router);
if (import.meta.hot) import.meta.hot.dispose(disconnectAnalytics);

const container = document.getElementById("root");

if (!container) {
  throw new Error("React failed to render. Could not find `root` element");
}

const root = createRoot(container, { onCaughtError: logCaughtError });

root.render(
  <StrictMode>
    <RouterProvider router={router} useTransitions onError={logRouterError} />
  </StrictMode>,
);
